import {userPreferencesVar} from "../../common/user/settings/cache";
import {ICON_LIBRARY_BY_ID, buildIconConfig} from "./icon-library";

/**
 * The icon each vehicle type falls back to, as library entries, so a default and the same icon
 * picked by hand are built by the same code and cannot drift apart.
 */
export const DEFAULT_VEHICLE_TYPE_CONFIG = {
    '1': ICON_LIBRARY_BY_ID['default-truck'],
    '2': ICON_LIBRARY_BY_ID['default-tracker'],
    '4': ICON_LIBRARY_BY_ID['asset-silver-disc'],
    '5': ICON_LIBRARY_BY_ID['asset-yellow-hauler']
};

const FALLBACK_VEHICLE_TYPE_ID = '2';

/**
 * The entry the user picked for this vehicle type, or null: an absent, malformed or unknown
 * preference must degrade to the default rather than break the map (D4), and vehicle-type ids are
 * an open set the master can extend.
 */
const findPreferredEntry = (vehicleTypeID) => {
    if(vehicleTypeID === null || vehicleTypeID === undefined || vehicleTypeID === '')
    {
        return null;
    }
    const saved = userPreferencesVar()?.vehicleTypeIcons;
    if(!Array.isArray(saved))
    {
        return null;
    }
    const wanted = `${vehicleTypeID}`;
    for(const entry of saved)
    {
        if(`${entry?.vehicleTypeID}` === wanted)
        {
            return typeof entry?.iconID === 'string'? (ICON_LIBRARY_BY_ID[entry.iconID] ?? null): null;
        }
    }
    return null;
};

/**
 * The default entry for a vehicle type, falling back to the tracker glyph for an unknown id. Own
 * properties only, so an id like 'constructor' resolves to the fallback instead of to `Object`.
 */
const findDefaultEntry = (vehicleTypeID) => {
    const wanted = `${vehicleTypeID}`;
    return Object.prototype.hasOwnProperty.call(DEFAULT_VEHICLE_TYPE_CONFIG, wanted)?
        DEFAULT_VEHICLE_TYPE_CONFIG[wanted]:
        DEFAULT_VEHICLE_TYPE_CONFIG[FALLBACK_VEHICLE_TYPE_ID];
};

/**
 * The library entry a vehicle type's markers are drawn from: the picked icon when there is one,
 * the type's default otherwise.
 */
export const resolveVehicleIconEntry = (vehicleTypeID=null) => {
    return findPreferredEntry(vehicleTypeID) ?? findDefaultEntry(vehicleTypeID);
};

/**
 * The resolved entry as a Maps icon config. Reads the preference here rather than taking it as an
 * argument so no call site changes signature (D5).
 */
export const resolveVehicleIconConfig = ({vehicleTypeID=null, fillColor, maps}) => {
    return buildIconConfig(resolveVehicleIconEntry(vehicleTypeID), {maps, fillColor});
};

export const getTrackerSvgMarker = ({maps, fillColor, vehicleTypeID=null}) => {
    return resolveVehicleIconConfig({vehicleTypeID, fillColor, maps});
};
